/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useFieldArray, useFormContext } from "react-hook-form";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { InfoBox } from "../../../../components/Infobox";
import { colors } from "../../../../components/colors";
import { StyledText } from "../../../../assets/typography/typography";
import { FormRow } from "../../../common/hook-form";
import { PrimaryButton } from "../../../../components/Buttons";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";
import { SelectProductInput } from "../../../../components/forms/inputs/SelectProductInput";

const infoBoxBodyStyle = css`
  display: flex;
  flex-direction: row;
  text-align: left;
  gap: 16px;
`;

const offerWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 100%;
`;

export const AppHomepageOffersSection = () => {
  const { control, getValues } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    name: "vouchers",
    control: control,
  });

  return (
    <CardContainer>
      <PageHeader
        title="Offers"
        subtitle="Choose the offers you want to offer your users."
      />
      <CardBody css={cardBottomPadding}>
        <InfoBox backgroundColor={colors.ctaInactive} className="mb-2 p-5">
          <div css={infoBoxBodyStyle}>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              <FontAwesomeIcon icon={solid("info-circle")} />
            </StyledText>
            <StyledText
              color={colors.textPrimary}
              className="bodyTextSemibold mb-0"
            >
              Users can buy offers from the app homepage
            </StyledText>
          </div>
        </InfoBox>
        <div css={offerWrapperStyle}>
          {fields.map((field, index) => (
            <FormRow key={field.id}>
              <SelectProductInput
                label={`Offer ${index + 1}`}
                classification="admin-vouchers"
                name={`vouchers.${index}.id`}
                helperText="Choose the offer you want to display on the homepage"
                filterProductsFunction={(products) => {
                  const selectedOfferId = getValues(
                    `vouchers.${index}.id` as any
                  );

                  const selectedOffers = products?.find((p) => {
                    return p.id === selectedOfferId;
                  });

                  const optionsWithoutSelectedOffer = (products || []).filter(
                    (x) => {
                      return getValues("vouchers").every((field: any) => {
                        return field.id !== x.id;
                      });
                    }
                  );

                  const options = [
                    ...optionsWithoutSelectedOffer,
                    ...(selectedOffers ? [selectedOffers] : []),
                  ];

                  return options;
                }}
              />
              <PrimaryButton
                type="button"
                hoverColor={colors.errorLight}
                className="position-relative"
                style={{ top: "20px" }}
                color={colors.errorDark}
                backgroundColor="white"
                onClick={() => remove(index)}
              >
                Remove
              </PrimaryButton>
            </FormRow>
          ))}
          <PrimaryButton
            color={colors.textPrimary}
            backgroundColor={colors.transparent}
            hoverColor={colors.ctaLight}
            width={"fit-content"}
            icon={<FontAwesomeIcon icon={solid("plus")} />}
            type="button"
            onClick={() =>
              append({
                id: "",
              })
            }
          >
            Add offer
          </PrimaryButton>
        </div>
      </CardBody>
    </CardContainer>
  );
};
